export enum FacetType {
  brand = 'brand',
  colours = 'colours',
  navcolour = 'navigationColour',
  category = 'category',
  department = 'department',
  rating = 'customerRating',
}
